export const toPath = (name: string): string => {
    if (typeof name !== 'undefined' && name) {
        return name.replace(/-/g, '')
            .replace(/\s/g, '-')
            .replace(/[.,]/g, '')
            .toLowerCase();
    } else {
        return '';
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/helpers/toPath.ts